import React, { PureComponent } from 'react';
import { Form, Input, Modal, Button } from 'antd';
import moment from 'moment';
import includes from 'lodash/includes';
import last from 'lodash/last';

import {
  NotesContainer,
  listStyle,
  listStyleHighlighted,
  timeStamp,
  timeStampHighlighted,
  noteContent,
  noteContentHighlighted,
  StyledList,
  SubmitButton,
  FormItem,
  FormItemGrow,
  ScrollableDiv,
  NoteCard,
  NoteTitle,
  ModalTitle,
  NoteCardTitle,
} from './styled';
import P from '../../../components/P';

function filterNotesAndSort(notes = []) {
  return notes
    .filter((n) => !includes(['customer-to-mechanic', 'seen-note-marker'], n.noteType))
    .sort((a, b) => (a.created > b.created ? 1 : -1));
}

class CaseManagerNotes extends PureComponent {
  state = {
    notesScrollableHeight: 0,
    note: '',
    isModalVisible: false,
  };

  componentDidMount() {
    this.scrollToBottom();

    let height = 50;
    const detailsSection = document.querySelector('.js-booking-details-section');

    if (detailsSection) {
      height = detailsSection.offsetHeight - 65 - 20 - 16 - 15;
    }

    this.setState({ notesScrollableHeight: height });
  }

  componentDidUpdate(prevProps) {
    const prevNotes = filterNotesAndSort(prevProps.notes);
    const currentNotes = filterNotesAndSort(this.props.notes);

    if (prevNotes.length + 1 === currentNotes.length) {
      this.scrollToBottom();
    }
  }

  onValidateForm = (ev) => {
    ev.preventDefault();
    this.props.addNoteAction({
      ownerType: 'booking',
      content: ev.target[0].value,
    });
    this.setState({ note: '' });
  };

  onChangeInput = (ev) => {
    this.setState({ note: ev.target.value });
  };

  scrollToBottom = () => {
    const domEl = this.scrollableEl;
    if (!domEl) return;
    domEl.scrollTop = domEl.scrollHeight - domEl.clientHeight;
  };

  render() {
    const { notesScrollableHeight, isModalVisible } = this.state;
    const { notes = [], marker } = this.props;

    const filteredNotes = filterNotesAndSort(notes);
    const lastNote = last(filteredNotes);
    const isLastNote = (note) => lastNote && note.noteId === lastNote.noteId;

    const listItems = filteredNotes.map((note) => {
      const style = (isLastNote(note) && marker && listStyleHighlighted) || listStyle;
      const contentStyle = (isLastNote(note) && marker && noteContentHighlighted) || noteContent;
      const timeStampStyle = (isLastNote(note) && marker && timeStampHighlighted) || timeStamp;

      return (
        <li
          key={note.created}
          style={style}
          className={isLastNote(note) && marker ? 'new-note-highlighted' : ''}
        >
          <P style={timeStampStyle}>{moment(note.created).format('DD/MM/YY HH:mm')}</P>
          <P style={contentStyle}>
            <b>{note.generatedBy}</b>: {note.content}
          </P>
        </li>
      );
    });

    return (
      <>
        <NotesContainer>
          <NoteCard>
            <NoteCardTitle>
              <NoteTitle>Notes</NoteTitle>
              {!!listItems?.length && (
                <Button type="link" onClick={() => this.setState({ isModalVisible: true })}>
                  Expand notes
                </Button>
              )}
            </NoteCardTitle>
            <ScrollableDiv
              ref={(el) => {
                this.scrollableEl = el;
              }}
              style={{ height: notesScrollableHeight, maxHeight: notesScrollableHeight }}
            >
              {listItems}
            </ScrollableDiv>

            <StyledList>
              <Form layout="inline" onSubmit={this.onValidateForm}>
                <FormItemGrow>
                  <Input
                    value={this.state.note}
                    onChange={this.onChangeInput}
                    placeholder="Type a message here"
                    required
                  />
                </FormItemGrow>
                <FormItem>
                  <SubmitButton htmlType="submit">
                    <img src="/assets/images/arrow-right.svg" alt="enter" />
                  </SubmitButton>
                </FormItem>
              </Form>
            </StyledList>
          </NoteCard>
        </NotesContainer>
        <Modal
          title={<ModalTitle>Notes</ModalTitle>}
          visible={isModalVisible}
          width="70vw"
          footer={null}
          onCancel={() => this.setState({ isModalVisible: false })}
        >
          {listItems}
        </Modal>
      </>
    );
  }
}

export default CaseManagerNotes;
